import { Navigate, RouteObject } from "react-router";
import { OmniDataSheetsBaseDataRoute } from "@/routes/base-data/processes/omni/data-sheets/data-sheets-route";
import { OmniOffersBaseDataRoute } from "@/routes/base-data/processes/omni/offers/offers-route";
import { OmniOfferBaseDataRoute } from "@/routes/base-data/processes/omni/offers/[offerBaseDataId]/offer-base-data-route";
import { OmniContractsBaseDataRoute } from "@/routes/base-data/processes/omni/contracts/contracts-route";
import { OmniContractBaseDataRoute } from "@/routes/base-data/processes/omni/contracts/[contractBaseDataId]/contract-base-data-route";
import { OmniScopeOfWorksBaseDataRoute } from "@/routes/base-data/processes/omni/scope-of-works/scope-of-works-route";
import { OmniScopeOfWorkBaseDataRoute } from "@/routes/base-data/processes/omni/scope-of-works/[scopeOfWorkBaseDataId]/scope-of-work-base-data-route";
import { OmniPositionsBaseDataRoute } from "@/routes/base-data/processes/omni/positions/positions-route";
import { OmniPositionBaseDataRoute } from "@/routes/base-data/processes/omni/positions/[positionsBaseDataId]/positions-base-data-route";

export const omniBaseDataRoutes: RouteObject[] = [
  { index: true, element: <Navigate to="offers" replace /> },
  { path: "offers", element: <OmniOffersBaseDataRoute /> },
  { path: "offers/:offerBaseDataId", element: <OmniOfferBaseDataRoute /> },
  { path: "contracts", element: <OmniContractsBaseDataRoute /> },
  {
    path: "contracts/:contractBaseDataId",
    element: <OmniContractBaseDataRoute />,
  },
  { path: "scope-of-works", element: <OmniScopeOfWorksBaseDataRoute /> },
  {
    path: "scope-of-works/:scopeOfWorkBaseDataId",
    element: <OmniScopeOfWorkBaseDataRoute />,
  },
  { path: "positions", element: <OmniPositionsBaseDataRoute /> },
  {
    path: "positions/:positionsBaseDataId",
    element: <OmniPositionBaseDataRoute />,
  },
  { path: "data-sheets", element: <OmniDataSheetsBaseDataRoute /> },
];
